<script setup>
import { ref } from 'vue';
import { useI18n } from 'vue-i18n';

import { errorMessage } from '@/api/client';
import BaseModal from '@/components/BaseModal.vue';
import { useAuthStore } from '@/stores/auth';
import { useUiStore } from '@/stores/ui';

const emit = defineEmits(['close']);
const auth = useAuthStore();
const ui = useUiStore();
const { t } = useI18n();

const identifier = ref('');
const password = ref('');
const busy = ref(false);
const error = ref('');

async function submit() {
  if (busy.value) return;
  busy.value = true;
  error.value = '';
  try {
    await auth.logIn(identifier.value, password.value);
    // Nessun window.location.reload(): lo store è reattivo e l'interfaccia
    // si aggiorna da sola. L'originale ricaricava la pagina perché non aveva
    // modo di propagare il cambio di sessione.
    ui.notify(`${t('logInLink')} ✓`);
    emit('close', true);
  } catch (err) {
    error.value = errorMessage(err, t('loadFailed'));
  } finally {
    busy.value = false;
  }
}
</script>

<template>
  <BaseModal :title="$t('loginTitle')" @close="emit('close')">
    <!-- <form>: l'Invio invia, senza dover intercettare keyCode 13 a mano. -->
    <form id="login-form" @submit.prevent="submit">
      <label class="field">
        <span class="field__label">{{ $t('loginIdentifierLabel') }}</span>
        <input
          v-model="identifier"
          class="input"
          type="text"
          autocomplete="username"
          autofocus
          required
          :placeholder="$t('loginIdentifierPlaceholder')"
        />
      </label>

      <label class="field">
        <span class="field__label">{{ $t('passwordLabel') }}</span>
        <input
          v-model="password"
          class="input"
          type="password"
          autocomplete="current-password"
          required
          :placeholder="$t('passwordLoginPlaceholder')"
        />
      </label>

      <p v-if="error" class="field__error" role="alert">{{ error }}</p>
    </form>

    <template #footer>
      <button class="btn" type="button" @click="emit('close')">{{ $t('cancelButton') }}</button>
      <button class="btn btn--primary" type="submit" form="login-form" :disabled="busy">
        {{ $t('loginButton') }}
      </button>
    </template>
  </BaseModal>
</template>
